import { PDFViewer } from '@react-pdf/renderer';
import { SkillsMemberCertificationModelList } from 'generated-types/skills/certification';
import { SkillsEducationModelList } from 'generated-types/skills/education';
import { SkillsExperienceModelList } from 'generated-types/skills/experience';
import { SkillsMemberModel } from 'generated-types/skills/member';
import { SkillsSkillModelList } from 'generated-types/skills/skill';
import { Panel } from 'rsuite';

import { PdfCV } from './pdf-cv';
import { ResumeProfileModel } from 'generated-types/skills/resume_profile';

export const PdfViewer = ({
    selectedResumeProfile,
    circlesExperiences,
    otherExperiences,
    skillsMember,
    certifications,
    memberSkills,
    educations,
    externalPicture,
    anonymous,
}: {
    selectedResumeProfile: ResumeProfileModel;
    circlesExperiences: SkillsExperienceModelList;
    otherExperiences: SkillsExperienceModelList;
    skillsMember: SkillsMemberModel;
    certifications: SkillsMemberCertificationModelList;
    memberSkills: SkillsSkillModelList;
    educations: SkillsEducationModelList;
    externalPicture?: string;
    anonymous?: boolean;
}) => (
    <>
        <Panel>
            <PDFViewer width="100%" height="1000px">
                <PdfCV
                    selectedResumeProfile={selectedResumeProfile}
                    circlesExperiences={circlesExperiences}
                    otherExperiences={otherExperiences}
                    member={skillsMember}
                    skills={memberSkills}
                    certifications={certifications}
                    educations={educations}
                    externalPicture={externalPicture}
                    anonymous={anonymous}
                />
            </PDFViewer>
        </Panel>
    </>
);
